import { uniqueId } from 'lodash';

const decodeKeys = {
  FacilityID: 'id',
  LegacyFacilityID: 'legacyId',
  OrgFacilityID: 'orgRefId',
  ParentOrgID: 'orgId',
  ParentRecAreaID: 'recAreaId',
  FacilityName: 'name',
  FacilityDescription: 'description',
  FacilityTypeDescription: 'typeDescription',
  FacilityUseFeeDescription: 'feeDescription',
  FacilityDirections: 'directions',
  FacilityPhone: 'phone',
  FacilityEmail: 'email',
  FacilityReservationURL: 'reservationUrl',
  FacilityMapURL: 'mapUrl',
  FacilityAdaAccess: 'adaAccess',
  FacilityLongitude: 'longitude',
  FacilityLatitude: 'latitude',
  StayLimit: 'stayLimit',
  Keywords: 'keywords',
  Enabled: 'enabled',
  Reservable: 'reservable',
  LastUpdatedDate: 'lastUpdatedDate'
};
const encodeKeys = {
  id: 'facilityID',
  orgId: 'orgID',
  recAreaId: 'parentRecAreaID',
  orgRefId: 'legacyFacilityIDOrg',
  name: 'facilityName',
  description: 'facilityDescription',
  typeDescription: 'facilityTypeDescription',
  feeDescription: 'facilityUseFeeDescription',
  directions: 'facilityDirections',
  phone: 'facilityPhone',
  email: 'facilityEmail',
  reservationUrl: 'facilityReservationURL',
  mapUrl: 'facilityMapURL',
  adaAccess: 'facilityAdaAccess',
  longitude: 'facilityLongitude',
  latitude: 'facilityLatitude',
  stayLimit: 'stayLimit',
  enabled: 'enabled',
  reservable: 'reservable',
  keywords: 'keywords'
};

// Facility RecArea
function decodeRecAreas(records) {
  return records.map((record) => ({
    _key: uniqueId('recarea-'),
    id: record.RecAreaID,
    name: record.RecAreaName,
    link: record.ResourceLink
  }));
}

// FacilityAddresses
const decodeAddressKeys = {
  FacilityAddressID: 'id',
  FacilityID: 'assetId',
  FacilityAddressType: 'type',
  FacilityStreetAddress1: 'address1',
  FacilityStreetAddress2: 'address2',
  FacilityStreetAddress3: 'address3',
  City: 'city',
  PostalCode: 'postalCode',
  AddressStateCode: 'stateCode',
  AddressCountryCode: 'countryCode',
  LastUpdatedDate: 'lastUpdatedDate'
};
const encodeAddressKeys = {
  id: 'facilityAddressID',
  assetId: 'facilityID',
  type: 'facilityAddressType',
  address1: 'facilityStreetAddress1',
  address2: 'facilityStreetAddress2',
  address3: 'facilityStreetAddress3',
  city: 'city',
  postalCode: 'postalCode',
  stateCode: 'addressStateCode',
  countryCode: 'addressCountryCode'
};

function decodeAddresses(records) {
  return records.map((record) => {
    const address = { _key: uniqueId('address-')};
    Object.keys(decodeAddressKeys).forEach((key) => address[decodeAddressKeys[key]] = record[key]);
    return address;
  });
}

export const encodeFacilityAddress = (record) => {
  const address = {};
  Object.keys(encodeAddressKeys).forEach((key) => address[encodeAddressKeys[key]] = record[key]);
  return address;
};

// Facility Activities
const decodeActivityKeys = {
  ActivityID: 'activityId',
  ActivityParentID: 'parentActivityId',
  FacilityID: 'assetId',
  ActivityName: 'name',
  FacilityActivityDescription: 'description',
  FacilityActivityFeeDescription: 'feeDescription'
};
const encodeActivityKeys = {
  activityId: 'activityID',
  assetId: 'facilityID'
};

function decodeActivities(records) {
  return records.map((record) => {
    const activity = { _key: uniqueId('activity-')};
    Object.keys(decodeActivityKeys).forEach((key) => activity[decodeActivityKeys[key]] = record[key]);
    return activity;
  });
}

export const encodeFacilityActivity = (record) => {
  const activity = {};
  Object.keys(encodeActivityKeys).forEach((key) => activity[encodeActivityKeys[key]] = record[key]);
  return activity;
};

export const decodeFacility = (record) => {
  const asset = { _key: uniqueId('asset-')};

  Object.keys(decodeKeys).forEach((key) => asset[decodeKeys[key]] = record[key]);

  asset.events = [];
  asset.recareas = decodeRecAreas(record.RECAREA);
  asset.addresses = decodeAddresses(record.FACILITYADDRESS);
  asset.activities = decodeActivities(record.ACTIVITY);

  return asset
};

export const encodeFacility = (record) => {
  const facility = {};

  Object.keys(encodeKeys).forEach((key) => facility[encodeKeys[key]] = record[key]);

  return facility;
};
